<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />
    <div class="relative">
      <button
        @click="backToInitial()"
        class="cursor-pointer z-10 absolute top-0 mt-3 left-0 flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
      >
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="rgb(79 70 229)"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </button>

      <div
        class="tips__wrapper px-5 sm:px-10 justify-center items-center lg:py-10"
      >
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-10">
          <div class="relative">
            <img
              src="https://www.socialmediaexaminer.com/wp-content/uploads/2018/10/facebook-split-testing-audience-variable-1200.png"
              alt=""
            />
            <div
              class="container__title absolute top-0 right-0 w-56 h-24 p-4 rounded-xl flex items-center justify-items-center"
            >
              <p class="font-semibold">
                The power of splite-tes and custom audience lookalikes
              </p>
            </div>
          </div>
          <div class="flex flex-col px-3 py-5">
            <h3 class="text-indigo-500 font-semibold my-3">UGC</h3>
            <p class="text-sm leading-6">
              Peter Hahn is one of those brands that have put a lot effort into
              developing a comprehensive strategy to boost their ads
              performance. For them, the use of split-test to identify high
              performing ads reveal the importance of the combination of images
              and text for story ads. From there, the use of their most engaging
              and effective ad segment to create a lookalike audience was key to
              reach relevant customers and increase the return on ad spent do
              98%
            </p>
          </div>
        </div>
        <div
          class="my-20 bg-gradient-to-r from-gray-100 to-indigo-200 w-full p-10 rounded-lg text-center"
        >
          <h3 class="font-semibold py-2">This is a greate</h3>
          <p class="text-sm px-3 leading-6 sm:px-20">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam, autem
            consequuntur. Assumenda vitae perferendis impedit. Est temporibus
            architecto aliquid eligendi? Recusandae porro possimus asperiores
            delectus sapiente nesciunt ad rem accusamus?
          </p>
        </div>
        <div class="my-20 grid grid-flow-row gap-10">
          <div class="grid grid-flow-col px-5  sm:px-16 justify-around">
            <div class="grid justify-center justify-items-center">
              <div
                class="flex border-2 border-gray-600 p-5 w-20 h-20 rounded-lg justify-center items-end sm:w-32 sm:h-32"
              >
                <p class="font-semibold text-sm">Video Ads</p>
              </div>
              <p class="leading-5 mt-3 text-xs sm:text-sm text-center">
                Lorem Ipsum is simply dummy text of the printing and
              </p>
            </div>
            <div class="grid justify-center justify-items-center">
              <div
                class="flex border-2 border-gray-600 p-5 w-20 h-20 rounded-lg justify-center items-end sm:w-32 sm:h-32"
              >
                <p class="font-semibold text-xs sm:text-sm">Video Ads</p>
              </div>
              <p class="leading-5 mt-3 text-xs sm:text-sm text-center">
                Lorem Ipsum is simply dummy text of the printing and
              </p>
            </div>
            <div class="grid justify-center justify-items-center">
              <div
                class="flex border-2 border-gray-600 p-5 w-20 h-20 rounded-lg justify-center items-end sm:w-32 sm:h-32"
              >
                <p class="font-semibold text-xs sm:text-sm">Video Ads</p>
              </div>
              <p class="leading-5 mt-3 text-xs sm:text-sm text-center">
                Lorem Ipsum is simply dummy text of the printing and
              </p>
            </div>
          </div>
          <div class="grid grid-flow-col px-16 justify-around">
            <div class="grid justify-center justify-items-center">
              <div
                class="flex border-2 border-gray-600 p-5 w-20 h-20 rounded-lg justify-center items-end sm:w-32 sm:h-32"
              >
                <p class="font-semibold text-xs sm:text-sm">Video Ads</p>
              </div>
              <p class="leading-5 mt-3 text-xs sm:text-sm text-center">
                Lorem Ipsum is simply dummy text of the printing and
              </p>
            </div>
            <div class="grid justify-center justify-items-center">
              <div
                class="flex border-2 border-gray-600 p-5 w-20 h-20 rounded-lg justify-center items-end sm:w-32 sm:h-32"
              >
                <p class="font-semibold text-xs sm:text-sm">Video Ads</p>
              </div>
              <p class="leading-5 mt-3 text-xs sm:text-sm text-center">
                Lorem Ipsum is simply dummy text of the printing and
              </p>
            </div>
          </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 my-20 gap-10">
          <div class="bg-gray-200 p-10 rounded-xl">
            <h3 class="text-indigo-500 font-semibold my-3">UGC</h3>
            <p class="text-sm leading-6">
              Peter Hahn is one of those brands that have put a lot effort into
              developing a comprehensive strategy to boost their ads
              performance. For them, the use of split-test to identify high
              performing ads reveal the importance of the combination of images
              and text for story ads. From there, the use of their most engaging
              and effective ad segment to create a lookalike audience was key to
              reach relevant customers and increase the return on ad spent do
              98%
            </p>
            <button
              class="bg-indigo-500 p-2 text-sm rounded-lg my-3 text-white"
            >
              All ads
            </button>
          </div>
          <div class="flex h-full w-full">
            <img
              src="https://www.socialmediaexaminer.com/wp-content/uploads/2018/10/facebook-split-testing-audience-variable-1200.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount } from "vue";
import { useStore } from "vuex";
// import Icon from "@/components/UI/Icon";
import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import { useRouter } from "vue-router";
export default {
  components: { HeaderApp, AdblockTopbar },
  setup() {
    const store = useStore();
    const router = useRouter();
    const backToInitial = () => {
      router.push("/case-studies");
    };
    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      }
    });

    const roleUser = computed(() => store.state.role);

    return {
      roleUser,
      backToInitial,
    };
  },
};
</script>

<style scoped>
.case__wrapper {
  @apply grid;
}
.container__title {
  top: -15px;
  right: -15px;
  background-color: #edf2f7;
}
</style>
